module.exports = __webpack_public_path__ + "img/q2.4ca45f72.png";